import { memo, useCallback, useState } from "react";
import { getDashboardUrl } from "../../core/auth";
import { useAuth } from "../../core/auth-provider";
import { FeedbackModal } from "./feedback-modal";

export const ExitOnboardingButton = memo(function ExitOnboardingButton({
  className,
  skipPrompt = false,
  textClassName,
}: {
  className?: string;
  skipPrompt?: boolean;
  textClassName?: string;
}) {
  const auth = useAuth();
  const href = getDashboardUrl(auth?.token);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = useCallback(() => {
    if (skipPrompt) {
      window.location.href = href;
      return;
    }
    setIsModalOpen(true);
  }, [href, skipPrompt]);

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const handleConfirm = useCallback(() => {
    window.location.href = href;
  }, [href]);

  return (
    <>
      <button className={className} onClick={handleButtonClick} type="button">
        <span className={textClassName}>Exit to Dashboard</span>
      </button>
      {!skipPrompt && (
        <FeedbackModal
          isOpen={isModalOpen}
          onClose={handleClose}
          onConfirm={handleConfirm}
        />
      )}
    </>
  );
});
